import { render, staticRenderFns } from "./EnvironmentMetadataSection.vue?vue&type=template&id=e99b5cd6&scoped=true&"
import script from "./EnvironmentMetadataSection.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentMetadataSection.vue?vue&type=script&lang=ts&"
import style0 from "./EnvironmentMetadataSection.vue?vue&type=style&index=0&id=e99b5cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99b5cd6",
  null
  
)

export default component.exports